import { useEffect } from 'react';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useMessagingResource } from './use-messaging-resource';
import { ConversationParticipantView, ConversationView } from '@mark43/cad-api';
import { MessagingStore } from '../../store/messaging-store';

export const useMessagingBootstrap = (
    store: MessagingStore
): UseQueryResult<{
    bookmarkedConversations: ConversationView[];
    conversations: ConversationView[];
    participantIdentities: ConversationParticipantView[];
}> => {
    const { getConversationsBootstrapData, getBookmarkedConversations } = useMessagingResource();

    const getConversationsBootstrapDataQuery = useQuery(
        ['messaging-bootstrap'],
        async () => {
            const {
                conversationViews: conversations,
                conversationParticipantViews: participantIdentities,
            } = await getConversationsBootstrapData(store.lastReceivedMessageNudgeId);

            const bookmarkedConversations = await getBookmarkedConversations();

            return {
                bookmarkedConversations,
                conversations,
                participantIdentities,
            };
        },
        {
            cacheTime: Infinity,
            enabled: false,
            refetchOnMount: false,
            retry: 2,
            staleTime: Infinity,
            refetchOnWindowFocus: false,
        }
    );

    const { isError, refetch, isFetching } = getConversationsBootstrapDataQuery;

    useEffect(() => {
        store.setMessagingBootstrapState({ isFetching, isError, refetch });
    }, [isFetching, isError, refetch, store]);

    return getConversationsBootstrapDataQuery;
};
